import {success, invalid, failure, request} from "./helpers";
import {SAVE_INSIGHTS_FILE_SETUP, SET_SETTINGS_WEBSITE_ID, CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR} from '../actions/settings'

export const settings = (state={}, action) => {
	switch(action.type) {
		case request(SAVE_INSIGHTS_FILE_SETUP):
			return {
				...state,
				insights_file_save_success: undefined,
				insights_file_on_saving: true
			}
		case success(SAVE_INSIGHTS_FILE_SETUP):
			return {
				...state,
				insights_file_save_success: true,
				insights_file_on_saving: false,
			}
		case failure(SAVE_INSIGHTS_FILE_SETUP):
		case invalid(SAVE_INSIGHTS_FILE_SETUP):
			return {
				...state,
				insights_file_save_success: false,
				insights_file_on_saving: false,
				insights_file_save_error_message: action.payload.message
			}
		case CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR:
			return {
				...state,
				insights_file_save_success: false,
				insights_file_save_error_message: undefined
			}
		case SET_SETTINGS_WEBSITE_ID: 
			return {
				...state,
				insights_file_save_success: undefined,
				websiteId: action.value
			}
		default:
			return state
	}
}

export default {
	settings
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js